export const environment = {
  production: false,
  defaultCurrency: 'USD',
  apiUrl: 'https://qa.webapi.routes.codealo.com.ar/api',
  routesPublicApiUrl: 'https://qa.routes.codealo.com.ar',
  codealoUrl: 'https://dev.codealo.com.ar',
  firebase: {
    apiKey: "AIzaSyALL2eVuZKNZoI8TzuyzYTrep1g4OcsqWQ",
    authDomain: "rutealo-qa.firebaseapp.com",
    projectId: "rutealo-qa",
    storageBucket: "rutealo-qa.firebasestorage.app",
    messagingSenderId: "373978679305",
    appId: "1:373978679305:web:bd8fbd6619401f8d4150d8",
    measurementId: "G-5YV3Y9CY2M"
  },
};
